import { openInlineModal } from "./inlineModal.js";
import { openVideoModal } from "./videoModal.js";
import { openImageModal } from "./imageModal.js";
import { openSliderModal } from "./sliderModal.js";
import { equalizeCoachCardHeights } from "../equalSize.js";

export function initModal() {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("[data-modal-type]");
    if (!el) return;

    e.preventDefault();

    switch (el.dataset.modalType) {
      case "inline":
      openInlineModal({
        selector: el.dataset.src,
        onOpen: () => {
          equalizeCoachCardHeights();
        }
      });
        break;
      case "video":
        openVideoModal({ id: el.dataset.src });
        break;
      case "image":
        openImageModal({ src: el.dataset.src });
        break;
      case "slider":
        openSliderModal({
          trigger: el,
        });
        break;
    }
  });
}
